// externals
import type { Reducer } from 'redux';

// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { AltDealStructureState } from '@makemydeal/dr-dash-types';

// consts/enums
import { MARK_ALT_DEAL_STRUCTURES_FRESH, MARK_ALT_DEAL_STRUCTURES_STALE } from '../actionTypes/altDealStructureActionTypes';

export type AltDealStructureReducer = Reducer<AltDealStructureState>;

const initialState: AltDealStructureState = {
    isStale: true,
    lastFetchedAt: null
};

export const reducer: AltDealStructureReducer = (state = initialState, action: AnyFSA): AltDealStructureState => {
    switch (action.type) {
        case MARK_ALT_DEAL_STRUCTURES_STALE:
            return { ...state, isStale: true };
        case MARK_ALT_DEAL_STRUCTURES_FRESH:
            return { ...state, isStale: false, lastFetchedAt: Date.now() };
        default:
            return state;
    }
};
